export const SELF_REGISTRATION_REASONS = [
  "Plastisch-Kosmetische Operation",
  "Arbeitsunfähigkeit",
  "Sonstige ambulante Fragestellungen (wie z.B. Hilfsmittel, Rehabilitation)",
] as const;
